import styled from 'styled-components';
import { Row, Col, Button } from 'antd';
import media from 'styled-media-query';
import { Tab, Tabs, TabList, Panel, PanelList } from 'react-swipeable-tab';
import * as Title from 'vcomponents/Forms/Title';
import { Image } from 'semantic-ui-react';

export const Container = styled.div`
  font-family: Apple SD Gothic Neo !important;
  width: 100%;
  background: white;
  padding-bottom: 0 !important;
  ${(props) => (props.isIE ? 'max-width: 1400px' : '')}
`;
export const ContentView = styled.div`
  max-width: 1400px;
  margin: 0 auto;

  & h2 {
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
    width: 100%;
  }

  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
    width: 100%;
  }
`;

export const H2 = styled(Title.H2)``;
export const H3 = styled(Title.H3)`
  & h3 {
    color: #6d7582 !important;
  }
`;

export const ServiceItem = styled(Col)`
  padding-left: 15px;
  padding-right: 15px;

  margin-top: 45px;
  margin-bottom: 45px;

  & a {
    display: block;
    position: relative;
    z-index: 2;
  }

  & a img {
    box-shadow: 3px 4px 20px 0 rgb(0 0 0 / 10%);
    -webkit-transition: 0.7s cubic-bezier(0.26, 0.76, 0.3, 0.75);
    transition: 0.7s cubic-bezier(0.26, 0.76, 0.3, 0.75);
    width: 100% !important;
    border-radius: 6px;
    max-width: 100%;
  }

  &:hover {
    img {
      -webkit-transform: translate3d(0, -10px, 0);
      transform: translate3d(0, -10px, 0);
      box-shadow: 0 50px 80px -10px rgba(0, 0, 0, 0.17);
    }
  }

  & a .title {
    display: block;
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;

    text-align: left;
    padding: 25px 0 10px;
    color: #1f1f25;
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.2px;
    margin: 0;
  }

  & a .label-new {
    position: absolute;
    top: 5px;
    background: #f81f01;
    background: -webkit-linear-gradient(305deg, #f81f01, #ee076e);
    background: linear-gradient(145deg, #f81f01, #ee076e);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f81f01",endColorstr="#ee076e",GradientType=1);
    padding: 9px 14px;
    color: #fff;
    border-radius: 4px;
    font-size: 14px;
    line-height: 1;
    right: 5px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 500;
  }

  & a .info {
    padding: 0;
    color: rgba(29, 29, 36, 0.75);
    font-size: 14px;
    font-weight: 300;
    line-height: 25px;
  }
`;

export const CardRow = styled(Row)`
  padding-top: 80px;
  padding-bottom: 82px;

  & h2 {
    width: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 32px;
    line-height: 34px;
    letter-spacing: -0.02em;
    font-style: normal;
    color: #353C49;
    padding-bottom: 10px;
  }

  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    width: 100%;
    line-height: 22px;
    letter-spacing: -0.04em;
    color: #6D7582;
  }

  ${media.lessThan('medium')`
    /* screen width is less than 768px (medium) */
    padding-left: 30px!important;
    padding-right: 30px!important;
  `}

  ${media.between('medium', 'large')`
    /* screen width is between 768px (medium) and 1170px (large) */
    padding-left: 60px!important;
    padding-right: 60px!important;
  `}

  ${media.greaterThan('large')`
    /* screen width is greater than 1170px (large) */
    padding-left: 120px;
    padding-right: 120px;
  `}

`;
export const CardRow01 = styled(Row)`
  margin-top: 45px;
  margin-bottom: 30px;
  border-radius: 8px;

  ${media.lessThan('medium')`
    /* screen width is less than 768px (medium) */
    margin-left: 30px!important;
    margin-right: 30px!important;
  `}

  ${media.between('medium', 'large')`
    /* screen width is between 768px (medium) and 1170px (large) */
    margin-left: 60px!important;
    margin-right: 60px!important;
  `}

  ${media.greaterThan('large')`
    /* screen width is greater than 1170px (large) */
    margin-left: 120px;
    margin-right: 120px;
  `}

`;

export const CardRow02 = styled(Row)`
  padding-top: 60px;
  padding-bottom: 60px;
  margin-left: 120px;
  margin-right: 120px;
  background-color: #EBF9F1;

  & h2 {
    width: 100%;
    text-align: center;
    font-weight: 700;
    font-size: 32px;
    line-height: 34px;
    letter-spacing: -0.02em;
    font-style: normal;
    color: #353C49;
    padding-bottom: 10px;
    margin: 0;
  }
 
  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    width: 100%;
    line-height: 22px;
    letter-spacing: -0.04em;
    color: #6D7582;
  }


  ${media.lessThan('medium')`
    /* screen width is less than 768px (medium) */
    padding-left: 30px!important;
    padding-right: 30px!important;
  `}

  ${media.between('medium', 'large')`
    /* screen width is between 768px (medium) and 1170px (large) */
    padding-left: 60px!important;
    padding-right: 60px!important;
  `}

  ${media.greaterThan('large')`
    /* screen width is greater than 1170px (large) */
    padding-left: 120px;
    padding-right: 120px;
  `}
`;

export const CardRow03 = styled(Row)`
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;

  & > div {
    align-self: center;
  }

  background-color: #F3F5F6;
  & h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 38px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #FFFFFF;
  }

  & h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #D6E5F9;
  }

  & .imageContainer {
    max-width: 500px;
    display: flex;
    flex-direction: column;
  }

  & .imageContainer > div:first-child {
    display: flex;
    margin-bottom: 22px;
  }

  & .imageContainer > div:first-child > div:first-child {
    padding-right: 8px;
  }
  & .imageContainer > div:first-child > div:last-child {
    padding-left: 8px;
  }

  ${media.lessThan('medium')`
    /* screen width is less than 768px (medium) */
    padding-left: 30px!important;
    padding-right: 30px!important;
  `}

  ${media.between('medium', 'large')`
    /* screen width is between 768px (medium) and 1170px (large) */
    padding-left: 60px!important;
    padding-right: 60px!important;
  `}

  ${media.greaterThan('large')`
    /* screen width is greater than 1170px (large) */
    padding-left: 120px;
    padding-right: 120px;
  `}
`;

export const CardRow04 = styled(Row)`
  background: #3478f6;
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  height: 320px;

  & div {
    align-self: center;
  }

  & h2 {
    font-style: normal;
    font-weight: 700;
    font-size: 38px;
    line-height: 56px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #ffffff;
  }

  & h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.02em;
    color: #d6e5f9;
  }
`;

export const CardRow05 = styled(Row)``;

export const Card = styled(Col)`
  height: 330px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  & h2 {
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
  }

  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
  }

  & img {
  }
`;
export const TextCard = styled(Col)`
  height: 330px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding-left: 40px;

  & h2 {
    font-weight: 800;
    font-size: 28px;
    line-height: 40px;
  }

  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
  }

  & img {
  }
`;

export const Card02 = styled(Col)`
  height: 330px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding-left: 90px;
  & h2 {
    line-height: 40px;
    font-weight: 800;
    font-size: 28px;
  }

  & h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 28px;
  }

  & img {
  }
`;

export const Card03 = styled(Col)`
  padding-left: 10px;
  padding-right: 10px;
`;

export const Card03In = styled.div`
  background: #ffffff;
  border-radius: 8px;

  & .imgContainer {
    background: #e9ebf2;
    border-radius: 8px;
    height: 150px;
  }

  & .title {
    color: #27ae60;
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
  }

  & .txtContainer {
    padding: 30px;
  }
`;

export const LandingImage = styled(Row)`
  position: relative;

  & > img,
  .react-parallax,
  img.react-parallax-bgimage {
    min-height: 420px;
    object-fit: cover;
    width: 100%;
  }

  & .linear {
    align-content: flex-start;
    align-items: flex-start;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.48) 10%, rgba(255, 255, 255, 0));
    flex: none;
    flex-direction: column;
    flex-wrap: nowrap;
    height: 100%;
    justify-content: center;
    padding: 0px 0px 0px 120px;
    width: 50%;
    max-width: 50%;
    position: absolute;
  }
`;
export const LandingText = styled.div`
  position: absolute;
  top: 20%;
  left: 80px;

  & h2 {
    font-weight: 700;
    font-size: 36px;
    color: #353c49;
  }
  & h3 {
    font-size: 16px;
    line-height: 26px;
    color: #6d7582 !important;
    font-weight: 400;
    letter-spacing: -0.01em;
    margin-bottom: 32px;
  }
`;
export const ImageContainer01 = styled.div`
  // background: #f3f5f6;
  // border: 1px solid #eeeeee;
  // border-radius: 8px;
  // padding: 30px;
  // height: 330px;

  margin-bottom: 30px;
  width: 100%;
  box-sizing: border-box;

  & img {
    width: 100%;
  }
`;
export const ImageContainer02 = styled.div`
  // background: #f3f5f6;
  // border: 1px solid #eeeeee;
  box-sizing: border-box;
  // border-radius: 8px;
  padding: 30px;
  position: relative;
  overflow: hidden;
  height: 330px;

  & img {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
  }
`;

export const TabsWrapper = styled(Tabs)`
  & .react-swipeable-tab-tab.active,
  .react-swipeable-tab-iscroll-wrap {
    border-radius: 10px !important;
  }

  & .react-swipeable-tab-iscroll {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: flex-end !important;
  }

  & .react-swipeable-tab-tabList {
    height: 63px;
    margin-bottom: 20px;
  }

  & .gRvTHB .react-swipeable-tab-iscroll-wrap & .react-swipeable-tab-iscroll-wrap {
    background: #f3f5f6;
    box-sizing: border-box;
    border-radius: 20px;
    padding-bottom: 0px;
  }

  & .react-swipeable-tab-tab {
    color: #6d7582;
    cursor: pointer;
  }

  & .react-swipeable-tab-tab.active {
    background: #ffffff;
    border-radius: 10px;
    color: #6d7582;
    border: none;
    font-weight: bold;
    cursor: pointer;
  }

  & .react-swipeable-tab-panel {
    background: #f3f5f6;
    border: solid 1px #eee;
    border-radius: 8px;
    overflow: hidden;
  }

  & .react-swipeable-tab-panel > div > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  & .ink {
    background-color: transparent !important;
  }

  & h3 {
  }
`;
export const FullButton = styled(Button)`
  padding: 10px 40px 10px 40px;
  height: 45px;
  background: #3478f6;
  border-color: #3478f6;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  border-radius: 4px !important;
  width: 160px;
  padding: 10px 16px;
  color: #ffffff;
  text-shadow: none;

  & :hover {
    background: #448aff;
    border: 1px solid #448aff;
  }
`;
export const EmptyButton = styled(Button)`
  background: transparent;
  border: 1px solid #0067ff;
  box-sizing: border-box;
  border-radius: 4px !important;
  width: 120px;
  height: 45px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  color: #0067ff;
  padding: 10px 16px;
  text-shadow: none;

  & :focus {
    background: rgba(234, 243, 255, 0.2);
    border: 0.5px solid #0067ff;
    color: #0067ff;
  }

  & :hover {
    background: rgba(234, 243, 255, 0.2);
    border: 0.5px solid #0067ff;
    color: #0067ff;
  }

  /* identical to box height */

  /* Basic/Blue 03 */
`;
export const WhiteButton = styled(Button)`
  // padding: 10px 40px 10px 40px;
  border-color: #3478f6;
  width: 160px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgb(0, 0, 0, 0.1);
  border-radius: 3px;

  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.04em;
  color: #3478f6;

  & :hover {
    background: #f5f5f5;
    border-color: #3478f6;
    color: #3478f6;
  }
`;

export const TabListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
`;

export const BackgroundImage = styled(Image)`
  background-image : url("${(props) => props.logo}"); 
  background-size : cover;
  background-position: center;
  height: 420px;
`;
